/**
 * Copyright (c) ACT, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

export const LARGE_DATA = [
  {
    label: 'Texas',
    x: 70258,
    y: 26,
  },
  {
    label: 'California',
    x: 7793,
    y: 25,
  },
  {
    label: 'Florida',
    x: 4432,
    y: 13,
  },
  {
    label: 'Illinois',
    x: 3941,
    y: 22,
  },
  {
    label: 'Oklahoma',
    x: 3199,
    y: 11,
  },
  {
    label: 'Louisiana',
    x: 3152,
    y: 14,
  },
  {
    label: 'Georgia',
    x: 2954,
    y: 13,
  },
  {
    label: 'Colorado',
    x: 2594,
    y: 22,
  },
  {
    label: 'Arizona',
    x: 2349,
    y: 16,
  },
  {
    label: 'Ohio',
    x: 2231,
    y: 12,
  },
  {
    label: 'New York',
    x: 2171,
    y: 13,
  },
  {
    label: 'North Carolina',
    x: 2109,
    y: 15,
  },
  {
    label: 'Michigan',
    x: 2027,
    y: 17,
  },
  {
    label: 'Tennessee',
    x: 2015,
    y: 16,
  },
  {
    label: 'Pennsylvania',
    x: 1919,
    y: 17,
  },
  {
    label: 'Arkansas',
    x: 1914,
    y: 12,
  },
  {
    label: 'Missouri',
    x: 1793,
    y: 17,
  },
  {
    label: 'Washington',
    x: 1752,
    y: 19,
  },
  {
    label: 'New Jersey',
    x: 1746,
    y: 17,
  },
  {
    label: 'Virginia',
    x: 1735,
    y: 14,
  },
  {
    label: 'Indiana',
    x: 1698,
    y: 17,
  },
  {
    label: 'Alabama',
    x: 1690,
    y: 10,
  },
  {
    label: 'Minnesota',
    x: 1420,
    y: 24,
  },
  {
    label: 'Maryland',
    x: 1282,
    y: 17,
  },
  {
    label: 'South Carolina',
    x: 1218,
    y: 17,
  },
  {
    label: 'Kansas',
    x: 1184,
    y: 12,
  },
  {
    label: 'Mississippi',
    x: 1170,
    y: 8,
  },
  {
    label: 'Kentucky',
    x: 1007,
    y: 11,
  },
  {
    label: 'Massachusetts',
    x: 1000,
    y: 20,
  },
  {
    label: 'Wisconsin',
    x: 957,
    y: 17,
  },
  {
    label: 'Utah',
    x: 939,
    y: 8,
  },
  {
    label: 'New Mexico',
    x: 830,
    y: 14,
  },
  {
    label: 'Nevada',
    x: 805,
    y: 14,
  },
  {
    label: 'Oregon',
    x: 796,
    y: 18,
  },
  {
    label: 'Connecticut',
    x: 640,
    y: 18,
  },
  {
    label: 'Nebraska',
    x: 571,
    y: 10,
  },
  {
    label: 'Idaho',
    x: 569,
    y: 12,
  },
  {
    label: 'Iowa',
    x: 515,
    y: 9,
  },
  {
    label: 'Hawaii',
    x: 502,
    y: 18,
  },
  {
    label: 'West Virginia',
    x: 280,
    y: 7,
  },
  {
    label: 'South Dakota',
    x: 237,
    y: 8,
  },
  {
    label: 'Montana',
    x: 221,
    y: 9,
  },
  {
    label: 'New Hampshire',
    x: 219,
    y: 21,
  },
  {
    label: 'Delaware',
    x: 205,
    y: 11,
  },
  {
    label: 'Rhode Island',
    x: 170,
    y: 15,
  },
  {
    label: 'Wyoming',
    x: 136,
    y: 10,
  },
  {
    label: 'Maine',
    x: 136,
    y: 15,
  },
  {
    label: 'Alaska',
    x: 134,
    y: 13,
  },
  {
    label: 'North Dakota',
    x: 129,
    y: 9,
  },
  {
    label: 'District of Columbia',
    x: 74,
    y: 15,
  },
];

export const defaultData = [
  { label: 'FAFSA', x: 0.9, y: 32 },
  { label: 'SAT Scores', x: 0.85, y: 27 },
  { label: 'Website Inquiry', x: 1.8, y: 23 },
  { label: 'HS Visit/Counselor', x: 2.4, y: 20 },
  { label: 'Online Application', x: 3.9, y: 45 },
  { label: 'Purchased x', x: 5.8, y: 4 },
  { label: 'CAPEX INQs', x: 6.4, y: 6 },
  { label: 'Pro_Plus', x: 9.1, y: 3 },
  { label: 'Something Else', x: 9.1, y: 3 },
  { label: 'More Stuff', x: 9.3, y: 2.9 },
  { label: 'Private Colleges & Universities', x: 19.9, y: 40 },
];
